import React, { useState, useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import { get } from "lodash";
import { Link } from "@quintype/components";
import MenuItem from "../../layouts/menu-item";
import { NavMoreClose } from "../../atoms/Nav-More-Close";
import { NavMore } from "../../atoms/Nav-More";
import { DfpComponent } from "../../ads/dfp-component";
import "./section-mast.m.css";
import { PAGE_TYPE } from "../../../constants";

const SectionMast = () => {
  const [showMore, setShowMore] = useState(false);
  const currentPath = useSelector((state) => get(state, ["qt", "currentPath"], {}));

  const [deviceType, setDeviceType] = useState("desktop");
  const [width, setWidth] = useState(1200);

  const isMobile = deviceType === "mobile";

  const [showMoreButton, setShowMoreButton] = useState(false);
  const listItemRef = useRef(null);

  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const apiResponse = get(qtState, ["data"], {});
  const pageType = get(qtState, ["pageType"], null);
  const { menuGroups: menuGroupsList, story, coverImage, section, collection, tag } = apiResponse;

  const defaultMenuItems = get(menuGroupsList, ["menuGroups", "home-mast-menu", "items"], []);

  const coverImageUrl = coverImage?.["cover-image-url"];
  const isCoverImageExist = coverImage?.["cover-image-s3-key"];

  const specialPages = [
    { type: "forex-page", name: "Gold Forex", slug: "gold-forex" },
    { type: "gold-gcc-page", name: "Gold Forex", slug: "gold-forex" },
    { type: "prayer-times", name: "Prayer Times", slug: "prayer-times" },
    { type: "weather-page", name: "Weather", slug: "weather" },
    { type: "historical-gold-page", name: "Gold Forex", slug: "gold-forex" },
    { type: "historical-fuel-page", name: "Gold Forex", slug: "gold-forex" },
    { type: "historical-remmitance-page", name: "Gold Forex", slug: "gold-forex" },
    { type: "gratuity-calculator-page", name: "Gratuity Calculator", slug: "gratuity-calculator-uae" },
    { type: "entity-people-details", name: "GN List", slug: "people" },
    { type: "entity-page-people", name: "GN List", slug: "people" },
    { type: "entity-place-details", name: "GN List", slug: "places" },
    { type: "entity-page-places", name: "GN List", slug: "places" },
    { type: "entity-companies-details", name: "GN List", slug: "companies" },
    { type: "entity-page-companies", name: "GN List", slug: "companies" },
  ];
  function getSpecialPageSlugByType(type) {
    const page = specialPages.find((page) => page.type === type);
    return page ? page.slug : null; // Return slug if found, else return null
  }

  const specialPageTypes = ["static-page", "gn-reach", "gratuity-calculator-page"]; // Passing defaultMenuItems for these pageTypes

  const isSpecialPage = specialPages.filter((page) => {
    return page.type === pageType;
  });
  const isStaticPage = pageType === "static-page";
  const isTagPage = pageType === "tag-page";
  const isMagazineList = pageType === "magazine-listing-page";
  const isMagazineLanding = pageType === "magazine-landing-page";
  const isGoldGcc = pageType === "gold-gcc-page";
  const currentSection =
    (isSpecialPage?.length && isSpecialPage[0]) ||
    (isStaticPage && { name: apiResponse?.title }) ||
    (isMagazineList && { name: apiResponse?.magazine?.name }) ||
    (isMagazineLanding && { name: apiResponse?.data?.name }) ||
    get(story, ["sections", "0"], "") ||
    get(section, ["collection"], null) ||
    collection ||
    tag;
  const slug =
    (isMagazineList && apiResponse?.magazine?.slug) ||
    (isMagazineLanding && apiResponse?.data?.slug) ||
    story?.slug ||
    section?.["section-url"] ||
    getSpecialPageSlugByType(pageType) ||
    pageType;

  let sectionMenuList = [];
  const pathSegments = slug?.split("/").filter(Boolean);

  let currentSlug = pathSegments?.[pathSegments?.length - 1];

  if (pageType === PAGE_TYPE.SECTION_PAGE && (pathSegments?.[2] === "premium" || pathSegments?.[2] === "friday")) {
    // sub-sections created under PREMUIM
    // Hardcode SectionMenuList to "Premium" to avoid section name collision when a sub-section has the same name as a parent section
    sectionMenuList = menuGroupsList?.menuGroups?.[pathSegments?.[2]];
  } else {
    if (pageType === "magazine-landing-page") {
      const currentSegment = "gn-focus";
      sectionMenuList = menuGroupsList?.menuGroups?.[currentSegment];
    } else {
      for (let i = pathSegments?.length - 1; i >= 0; i--) {
        const currentSegment = pathSegments && pathSegments[i];

        if (menuGroupsList?.menuGroups && currentSegment && menuGroupsList?.menuGroups?.[currentSegment]) {
          sectionMenuList = menuGroupsList?.menuGroups?.[currentSegment];
          break;
        }
      }
    }
  }

  if (!sectionMenuList?.items?.length && currentSection) {
    sectionMenuList = {
      name: currentSection?.name,
      slug: currentSection?.slug,
      items: specialPageTypes.includes(pageType) ? defaultMenuItems : [],
    };
  }
  if (pageType === "gold-gcc-page") {
    const cleanUrl = currentPath?.split("?")[0];
    const segments = cleanUrl?.split("/").filter(Boolean);
    const slug = segments.pop();
    const urlToCountryCode = {
      "oman-gold-prices": "Oman gold prices",
      "saudi-gold-prices": "Saudi gold prices",
      "qatar-gold-prices": "Qatar gold prices",
      "kuwait-gold-prices": "Kuwait gold prices",
      "bahrain-gold-prices": "Bahrain gold prices",
      "india-gold-prices": "India gold prices",
    };
    sectionMenuList.slug = currentPath;
    sectionMenuList.name = urlToCountryCode[slug];
    currentSlug = slug;
  }
  let staticPageUrl = "#";
  if (isStaticPage && currentPath.includes("asia-cup")) {
    sectionMenuList = menuGroupsList?.menuGroups["asia-cup"];
    staticPageUrl = "/sport/asia-cup";
  }
  let isEntityPage = false;
  if (
    [
      "entity-page-people",
      "entity-page-places",
      "entity-page-companies",
      "entity-place-details",
      "entity-people-details",
      "entity-companies-details",
    ]?.includes(pageType)
  ) {
    sectionMenuList = menuGroupsList?.menuGroups["gn-list"];
    sectionMenuList.slug = currentSection?.slug;
    isEntityPage = true;
  }

  const toggleMore = () => {
    setShowMore(!showMore);
  };
  const hasCurrentSection = currentSection && Object.keys(currentSection).length;

  const HeaderLogo = ({ requiredClass }) =>
    isCoverImageExist ? (
      <Link href={`/${sectionMenuList?.slug}`}>
        <img src={coverImageUrl} styleName="cover-image" alt="Logo" />
      </Link>
    ) : isStaticPage || isTagPage || isGoldGcc ? (
      <Link href={`${staticPageUrl}`}>
        <div styleName={requiredClass}>{sectionMenuList?.name?.toUpperCase()}</div>
      </Link>
    ) : isMagazineList || isMagazineLanding ? (
      <Link href={`/magazine/${sectionMenuList?.slug}`}>
        <div styleName={requiredClass}>{sectionMenuList?.name?.toUpperCase()}</div>
      </Link>
    ) : (
      <Link href={`/${sectionMenuList?.slug}`}>
        <div styleName={requiredClass}>{sectionMenuList?.name?.toUpperCase()}</div>
      </Link>
    );

  const customStyleForMenuItem = {
    display: "flex",
    height: "22px",
  };
  const selectedCustomStyleForMenuItem = {
    display: "flex",
    height: "22px",
    fontWeight: 700,
    lineHeight: "150%",
  };

  const determineDeviceType = () => {
    setWidth(window.innerWidth);
    if (width < 768) {
      setDeviceType("mobile");
    } else if (width < 1200) {
      setDeviceType("tablet");
    } else {
      setDeviceType("desktop");
    }
  };

  useEffect(() => {
    const handleInitialLoad = () => {
      determineDeviceType();
      if ((sectionMenuList?.items?.length > 0 && isMobile) || listItemRef?.current?.offsetTop > 0) {
        setShowMoreButton(true);
      } else {
        setShowMoreButton(false);
      }
    };

    setTimeout(handleInitialLoad, 500);

    window.addEventListener("resize", determineDeviceType);
    return () => {
      window.removeEventListener("resize", determineDeviceType);
    };
  }, [width, deviceType]);

  return hasCurrentSection ? (
    <div styleName="section-mast-container-main">
      <div styleName="section-mast-header">
        <div styleName="section-mast-container-web">
          <HeaderLogo requiredClass={"logo-text-web"} />
        </div>
        <div
          styleName={`${
            sectionMenuList?.items?.length > 0 || hasCurrentSection || isMobile
              ? "section-mast-nav-container"
              : "section-menu-hidden"
          }`}
        >
          <div styleName="section-mast-container-mobile">
            <HeaderLogo requiredClass={"logo-text-mobile"} />
          </div>
          {sectionMenuList?.items?.length > 0 && (
            <ul styleName={`menu-group ${showMore ? "show-more" : "show-less"}`}>
              {sectionMenuList?.items?.map((menuItem, index) => {
                currentSlug = pageType === "story-page" ? slug : currentSlug;
                let menuSlug = menuItem?.["section-slug"];
                if (pageType === "gold-gcc-page" || pageType === "forex-page" || isEntityPage) {
                  const itemrlArr = menuItem?.url?.split("/");
                  menuSlug = itemrlArr[itemrlArr?.length - 1];
                }
                return (
                  <li key={menuItem.title} ref={index === sectionMenuList?.items?.length - 1 ? listItemRef : null}>
                    <MenuItem
                      item={menuItem}
                      menuStyle="menu-link"
                      fontSize="14px"
                      customStyle={menuSlug === currentSlug ? selectedCustomStyleForMenuItem : customStyleForMenuItem}
                    />
                  </li>
                );
              })}
            </ul>
          )}
          {showMoreButton && (
            <button styleName="more-btn" onClick={toggleMore}>
              {showMore ? <NavMoreClose /> : <NavMore />}
            </button>
          )}
        </div>
      </div>
    </div>
  ) : null;
};

export default SectionMast;
